import { Button } from '@lb-classroom/ui';
import { WithTranslation } from 'next-i18next';
import Link from 'next/link';
import React from 'react';
import { withTranslation } from 'next-i18next';

interface Props extends WithTranslation {
  planName: string;
}

const SubscribeButton: React.FC<Props> = ({ planName, t }: Props) => {
  if (planName === 'Trial') {
    return (
      <Link legacyBehavior href="/s/billing">
        <a>
          <Button>{t('links.subscribe')}</Button>
        </a>
      </Link>
    );
  }
  return null;
};

const wrapped = withTranslation('common')(SubscribeButton);

export default wrapped;
